import React from 'react';
import PropTypes from 'prop-types';
import { CcJsDataContextProvider } from '@bingads-webui-cc-react/js-data-rest';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { initCcJsData } from './init-cc-js-data';

export const withCcJsDataContextProvider = (WrappedComponent) => {
  const HOC = (props) => {
    const {
      serverContext, scope, cid, uid,
    } = props;
    const { values } = scope;
    const serverCtx = serverContext || {};

    // TO DO: eventually remove these checks
    if (!serverCtx.ServicesEndpoints) {
      serverCtx.ServicesEndpoints = {
        ClientCenterUIAPI: 'https://ADS-INT.MICROSOFT.COM/cc/',
      };
    }

    if (!serverCtx.CurrentUser) {
      serverCtx.CurrentUser = { Id: uid || values.uid };
    }

    if (!serverCtx.CurrentCustomer) {
      serverCtx.CurrentCustomer = { Id: cid || values.cid };
    }

    const { jsDataCcRest } = initCcJsData({ serverContext: serverCtx });

    return (
      <CcJsDataContextProvider initialJsData={jsDataCcRest}>
        <WrappedComponent {...props} />
      </CcJsDataContextProvider>
    );
  };

  HOC.propTypes = {
    serverContext: PropTypes.shape({
      CurrentUser: PropTypes.shape({ Id: PropTypes.number }),
      CurrentCustomer: PropTypes.shape({ Id: PropTypes.number }),
      ServicesEndpoints: PropTypes.shape({
        ClientCenterUIAPI: PropTypes.string,
      }),
    }).isRequired,
    scope: PropTypes.shape({
      values: PropTypes.shape({
        cid: PropTypes.number,
        uid: PropTypes.number,
      }),
    }),
    cid: PropTypes.number,
    uid: PropTypes.number,
  };

  HOC.defaultProps = {
    scope: { values: {} },
    cid: null,
    uid: null,
  };

  return withServerContext(HOC);
};
